//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import UserModal from "./UserModal";
export default {
  name: 'DeptUserInfo',
  mixins: [JeecgListMixin],
  components: {
    UserModal: UserModal
  },
  data: function data() {
    return {
      description: '用户信息',
      currentDeptId: '',
      // 表头
      columns: [{
        title: '用户账号',
        align: 'center',
        dataIndex: 'username'
      }, {
        title: '用户名称',
        align: 'center',
        dataIndex: 'realname'
      }, {
        title: '角色名称',
        align: 'center',
        dataIndex: 'roleList',
        scopedSlots: {
          customRender: 'roleList'
        }
      }, {
        title: '岗位名称',
        align: 'center',
        dataIndex: 'postList',
        scopedSlots: {
          customRender: 'postList'
        }
      }, {
        title: '手机号码',
        align: 'center',
        dataIndex: 'phone'
      }, {
        title: '邮箱',
        align: 'center',
        dataIndex: 'email'
      }, {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 70
      }],
      url: {
        list: '/sys/user/address/book/departUserList'
      }
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      } //加载数据 若传入参数1则加载第一页的内容


      if (arg === 1) {
        this.ipagination.current = 1;
      }

      if (this.currentDeptId === '') return;
      var params = this.getQueryParams(); //查询条件

      params.depId = this.currentDeptId;
      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    open: function open(record) {
      this.currentDeptId = record ? record.id : null;
      this.loadData(1);
    },
    clearList: function clearList() {
      this.currentDeptId = '';
      this.dataSource = [];
    }
  }
};